import BasePolicy from '@/policies/BasePolicy.js';

export default class ElearningPackagePolicy extends BasePolicy {
    viewAny(user) {
        return (
            user.hasPermissionTo('view all elearning packages') ||
            user.hasGroupPermissionTo('view all elearning packages')
        );
    }

    view(user) {
        return (
            user.hasPermissionTo('view all elearning packages') ||
            user.hasGroupPermissionTo('view all elearning packages') ||
            user.hasPermissionTo('view an elearning package') ||
            user.hasGroupPermissionTo('view an elearning package')
        );
    }

    hasAdminAccess(user) {
        return user;
    }
}
